
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("1O92x", function(module, exports) {

$parcel$export(module.exports, "Nav4RolloutAnalytics", () => $46bb6857eaae9023$export$89671fab480c820b);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $3F9p6 = parcelRequire("3F9p6");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $92h6i = parcelRequire("92h6i");

var $3HwlS = parcelRequire("3HwlS");


const $46bb6857eaae9023$export$89671fab480c820b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "nav4-rollout-analytics",
        fallback: "unmount",
        packageName: (0, $a96904e5be719c0e$export$b8b9d90f9e5bd72b),
        teamName: (0, $a96904e5be719c0e$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($46bb6857eaae9023$export$4bf890a38f5eb199, props));
const $46bb6857eaae9023$export$4bf890a38f5eb199 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // This should only run once. Fix for https://jplat.atlassian.net/browse/BLU-5516
    // and for React Concurrent.
    (0, $92h6i.useEffectWithoutConcurrency)(()=>{
        const nav4Rollout = (0, $3F9p6.getNav4Rollout)();
        // Now that the GA stage has started, nearly all tenants should be in a rollout stage.
        // Don't exclude tenants with a stage of 'none' as we may need to know who they are.
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'topNav viewed', {
            ...nav4Rollout,
            navState: (0, $3HwlS.getWillShowNav4)() ? (0, $1520d876660a71bd$export$2bd315ece9f68967) : (0, $1520d876660a71bd$export$d2aa6c54a5925f01)
        });
    }, [
        createAnalyticsEvent
    ]);
    return null;
};

});
parcelRegister("92h6i", function(module, exports) {

$parcel$export(module.exports, "useEffectWithoutConcurrency", () => $f224f3606a6cd92d$export$e44126cd87ea434);

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $3joPi = parcelRequire("3joPi");
function $f224f3606a6cd92d$export$e44126cd87ea434(effect, dependencies) {
    const effectCalledRef = (0, $5uXOq.useRef)(false);
    const depsRef = (0, $5uXOq.useRef)(dependencies);
    (0, $5uXOq.useEffect)(()=>{
        // If the dependencies have changed, reset the state of the ref.
        // This is how we catch the strict-mode execution.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(depsRef.current, dependencies)) {
            depsRef.current = dependencies;
            effectCalledRef.current = false;
        }
        // If the effect has already executed, we shouldn't be executing again unless we do a cleanup first.
        // This is the code that ignores the strict-mode update
        if (effectCalledRef.current) return;
        // Set this immediately
        effectCalledRef.current = true;
        const cleanup = effect();
        // If we do get a cleanup function, throw an error
        (0, $3joPi.default)(typeof cleanup !== 'function', 'useEffectWithoutConcurrency() cannot be used with cleanup functions');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}

});

const $1520d876660a71bd$export$d2aa6c54a5925f01 = 'v3';
const $1520d876660a71bd$export$2bd315ece9f68967 = 'v4';

const $a96904e5be719c0e$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4RolloutAnalytics';
const $a96904e5be719c0e$export$d57b6b390e78d90f = 'jira-cosmos';



//# sourceMappingURL=async-jira-navigation-apps-sidebar-nav4-rollout-analytics.2206fe71.js.map
